import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

const VotePage       = lazy(() => import("./pages/VotePage"));
const VenueDashboard = lazy(() => import("./pages/VenueDashboard"));
const VenueLogin     = lazy(() => import("./pages/VenueLogin"));
const Home           = lazy(() => import("./pages/Home"));
const TVDisplay      = lazy(() => import("./pages/TVDisplay"));
const AdminLogin     = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vote/:venueId" element={<VotePage />} />
        <Route path="/dashboard" element={<VenueDashboard />} />
        <Route path="/login" element={<VenueLogin />} />
        <Route path="/display/:venueId" element={<TVDisplay />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
